import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      const token = searchParams.get('token');
      const errorParam = searchParams.get('error');

      if (errorParam) {
        setError('Đăng nhập Google thất bại. Vui lòng thử lại.');
        setTimeout(() => {
          navigate('/login', { replace: true });
        }, 3000);
        return;
      }

      if (token) {
        try {
          await loginWithToken(token);
          navigate('/dashboard', { replace: true });
        } catch (err) {
          console.error('Google callback error:', err);
          setError('Đăng nhập thất bại. Vui lòng thử lại.');
          setTimeout(() => {
            navigate('/login', { replace: true });
          }, 3000);
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [searchParams, navigate, loginWithToken]);

  if (error) {
    return (
      <div className="min-h-screen bg-dark-900 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-400 text-xl mb-4">{error}</div>
          <p className="text-ocean-100/60">Đang chuyển hướng về trang đăng nhập...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center">
      <div className="text-center">
        <div className="relative mb-6">
          <div className="w-16 h-16 border-4 border-cyan-500/20 rounded-full mx-auto"></div>
          <div className="w-16 h-16 border-4 border-cyan-400 rounded-full animate-spin absolute top-0 left-1/2 -translate-x-1/2 border-t-transparent"></div>
        </div>
        <p className="text-ocean-100/80 text-lg">Đang xử lý đăng nhập Google...</p>
        <p className="text-ocean-100/50 text-sm mt-2">Vui lòng đợi trong giây lát</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
